import { doc, deleteDoc, updateDoc } from 'firebase/firestore'
import { db } from './firebase'

/**
 * Delete a collection by ID
 */
export async function deleteCollection(collectionId: string): Promise<void> {
  try {
    const collectionRef = doc(db, 'collections', collectionId)
    await deleteDoc(collectionRef)
    console.log('[collectionData] Collection deleted:', collectionId)
  } catch (error) {
    console.error('[collectionData] Error deleting collection:', error)
    throw error
  }
}

/**
 * Rename a collection
 */
export async function renameCollection(collectionId: string, newTitle: string): Promise<void> {
  try {
    const collectionRef = doc(db, 'collections', collectionId)
    await updateDoc(collectionRef, {
      title: newTitle.trim()
    })
    console.log('[collectionData] Collection renamed:', collectionId, newTitle)
  } catch (error) {
    console.error('[collectionData] Error renaming collection:', error)
    throw error
  }
}

